export default "__VITE_ASSET__CY9GeRn5__"